import { render, staticRenderFns } from "./item-info.vue?vue&type=template&id=e74ead9c&scoped=true"
import script from "./item-info.vue?vue&type=script&lang=js"
export * from "./item-info.vue?vue&type=script&lang=js"
import style0 from "./item-info.vue?vue&type=style&index=0&id=e74ead9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74ead9c",
  null
  
)

export default component.exports